import BaseStyle from 'primevue/base/style';

var classes = {
  root: function root(_ref) {
    var props = _ref.props;
    return ['p-steps p-component', {
      'p-readonly': props.readonly
    }];
  },
  menu: 'p-steps-list',
  menuitem: function menuitem(_ref2) {
    var instance = _ref2.instance,
      item = _ref2.item,
      index = _ref2.index;
    return ['p-steps-item', {
      'p-highlight p-steps-current': instance.isActive(index),
      'p-disabled': instance.isItemDisabled(item, index)
    }];
  },
  action: 'p-menuitem-link',
  step: 'p-steps-number',
  label: 'p-steps-title'
};
var StepsStyle = BaseStyle.extend({
  name: 'steps',
  classes: classes
});

export { StepsStyle as default };
